<template src="./ExchangeDeliveryData.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {ref, computed, reactive, onMounted, watch, nextTick} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useDeliveryStore} from "@/stores/delivery.js";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import {usePartnerStore} from "@/stores/partner.js";
import {AppConstant} from "@/supports/app.constant";
import {ConfirmText, ErrorMessageConstant, ErrorText} from "@/supports/error-message.constant";
import InputNumberComponent from "@/components/inputs/input-number/InputNumberComponent.vue";
import {useProductStore} from "@/stores/product.js";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import ErrorMessageService from "@/services/error-message.service.ts";
import {useWarehouseStore} from "@/stores/warehouse.js";
import ExportBillComponent from "@/components/export-bills/ExportBillComponent.vue";
import {useRouter} from "vue-router";
import {useStore} from "@/stores/store.js";
import {useSyncZalo} from "@/stores/syncZalo.js";
export default {
  name: 'ExchangeDeliveryData',
  components: {
    InputDateTimeNormal,
    InputCheckboxOne,
    InputNumberComponent,
    LoadingComponent,
    ModalDeliveryProductListComponent,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
    ExportBillComponent
  },
  setup() {
    const errors = ref(true)
    const dataExchangeDelivery = ref({
      exchange_delivery_name: {
        id: 'exchange_delivery_name',
        label: 'Tên phiếu giao hàng',
        placeholder: 'Tên phiếu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      warehouse_id: {
        id: 'warehouse_id',
        label: 'Kho hàng',
        placeholder: 'Kho hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      delivery_date: {
        id: 'delivery_date',
        label: 'Ngày giao hàng',
        placeholder: 'Ngày giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        min: CommonService.convertDateToString(new Date())
      },
      partner_id: {
        id: 'partner_id',
        label: 'Đối tác giao hàng',
        placeholder: 'Đối tác giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      delivery_id: {
        id: 'delivery_id',
        label: 'Dữ liệu giao hàng',
        placeholder: 'Dữ liệu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true,
        options: []
      },
      exchange_delivery_description: {
        id: 'exchange_delivery_description',
        label: 'Mô tả phiếu giao hàng',
        placeholder: 'Mô tả phiếu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: false
      },
    })
    const dataHeaderTable = ref({
      sortRecord: {
        label: '#',
        order: 1,
        width: '2%',
      },
      product_name: {
        label: 'Tên sản phẩm',
        order: 2,
        width: '15%',
      },
      product_code: {
        label: 'Mã sản phẩm',
        order: 3,
        width: '10%',
      },
      product_price: {
        label: 'Giá sản phẩm',
        order: 4,
        width: '10%',
      },
      product_selling_price: {
        label: 'Giá bán',
        order: 5,
        width: '10%',
      },
      product_quantity: {
        label: 'Số lượng',
        order: 6,
        width: '10%',
      },
      product_tax: {
        label: 'Thuế (%)',
        order: 7,
        width: '10%',
      },
      product_unit: {
        label: 'Đơn vị',
        order: 8,
        width: '10%',
      },
      product_total_origin: {
        label: 'Giá chưa tính thuế',
        order: 9,
        width: '12.5%',
      },
      product_total: {
        label: 'Giá tính thuế',
        order: 10,
        width: '12.5%',
      },
    })
    const labelSelectProduct = ref('Chọn sản phẩm')
    const eventClickShowModal = ref(false)
    const isLoading = ref(false)
    const totalPrice = ref(0)
    const useToStoreDelivery = ref(false)
    const disabledStoreDelivery = ref(true)
    const listProductsSelected = ref([])
    const listProductIds = ref([])
    const errorMessageApi = ref([])
    const partnerStore = usePartnerStore()
    const deliveryStore = useDeliveryStore()
    const accountStore = useAccountStore()
    const productStore = useProductStore()
    const warehouseStore = useWarehouseStore()
    const syncZaloStore = useSyncZalo()
    const storeCompStore = useStore()
    const isShowBill = ref(false);
    const dataBillToPrint = ref({});
    const stateModal = reactive({
      modalDeliveryProductList: null,
    })
    const router = useRouter()

    // set up modal and call api get list partner
    onMounted(() => {
      stateModal.modalDeliveryProductList = new bootstrap.Modal('#modaldeliveryProduct', {})
      getListPartner();
      getListStores();
      getListWarehouses();

      window.addEventListener('message', (event) => {
        if (event.data.type === 'PRINT_CANCELED') {
          if (Object.keys(dataBillToPrint.value).length > 0) {
            isShowBill.value = true;
          }
        }
      });
    })

    // listen change list partner
    const listPartners = computed(() => {
      return partnerStore.partners;
    });

    watch(() => productStore.productByIds, (newProducts) => {
      listProductsSelected.value = newProducts.map(product => {
        return { ...product, product_quantity_set: 0, total_price_origin: 0, total_price_tax: 0, error: false };
      });
    });

    watch(() => dataExchangeDelivery.value.partner_id.value, (newPartner) => {
      getListMasterDelivery(newPartner)
      listProductsSelected.value.forEach((product) => {
        product.error_empty_quantity = false
        product.error_selling = false
      })
    });

    watch(() => deliveryStore.masterDeliveries, (newListMasterDelivery) => {
      newListMasterDelivery.forEach((delivery) => {
        dataExchangeDelivery.value.delivery_id.options.push({
          name: delivery.exchange_delivery_name,
          value: delivery.id,
          detail: delivery.delivery_detail,
        })
      })
      listProductsSelected.value.forEach((product) => {
        product.error_empty_quantity = false
        product.error_selling = false
      })
    });

    watch(() => dataExchangeDelivery.value.delivery_id.value, (newDelivery) => {
      totalPrice.value = 0
      const deliverySelected = dataExchangeDelivery.value.delivery_id.options.filter((item) => parseInt(item.value) === parseInt(newDelivery))
      if(deliverySelected.length > 0) {
        const arrProduct = deliverySelected[0].detail
        for (const productId in arrProduct) {
          listProductIds.value.push(arrProduct[productId])
        }
      }
      getListProduct(listProductIds.value);
    });

    watch(() => storeCompStore.stores, (newListStores) => {
      if(newListStores.length) {
        newListStores.forEach((item) => {
          dataExchangeDelivery.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
    });

    watch(() => dataExchangeDelivery.value.store_id.value, (newStore) => {
      if(dataExchangeDelivery.value.delivery_id.value) {
        const listMasterDeliveriesStore = deliveryStore.masterDeliveries.filter((item) => {
          return item.store?.id === newStore
        })
        if(listMasterDeliveriesStore.length) {
          listMasterDeliveriesStore.forEach((masterDelivery) => {
            dataExchangeDelivery.value.delivery_id.options.push({
              name: masterDelivery.exchange_delivery_name,
              value: masterDelivery.id,
              detail: masterDelivery.delivery_detail,
            })
          })
        }
        const compareOdDelivery = dataExchangeDelivery.value.delivery_id.options.find((item) => {
          return item.value === dataExchangeDelivery.value.delivery_id.value;
        })
        if(!compareOdDelivery) {
          dataExchangeDelivery.value.delivery_id.value = ''
        }
      }
    });

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }
    async function getListWarehouses() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/list-warehouse';
      await warehouseStore.getListWarehouses(url, params);
      warehouseStore.warehouses.forEach((warehouse) => {
        dataExchangeDelivery.value.warehouse_id.options.push({
          name: warehouse.name,
          value: warehouse.id
        })
      })
    }
    // call api list partner
    async function getListPartner() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/partner-list';
      await partnerStore.getListPartners(url, params);
      partnerStore.partners.forEach((partner) => {
        dataExchangeDelivery.value.partner_id.options.push({
          name: partner.partner_name,
          value: partner.partner_company_id
        })
      })
    }

    // call api list master delivery
    async function getListMasterDelivery(delivery_id) {
      const params = {
        id: accountStore.account.company.id,
        mDeliveryId: delivery_id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/m-deliveries/list-master-deliveries';
      await deliveryStore.getListMasterDelivery(url, params);
    }

    // call api list product
    async function getListProduct(listProductIds) {
      const params = {
        company_id: accountStore.account.company.id,
        product_ids: listProductIds,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/product/product-list-id';
      await productStore.getListProductsByIds(url, params);
    }

    // create delivery
    async function createDelivery() {
      for (const item in dataExchangeDelivery.value) {
        validateForm(dataExchangeDelivery.value[item].value, item)
      }
      if(checkSubmitActive.value) {
        listProductsSelected.value.forEach((product) => {
          product.tax_rate = product.product_tax
          product.product_quantity = product.product_quantity_set
          delete product.error_empty_quantity;
          delete product.error_selling;
        })
        const params = {
          m_company_id: accountStore.account.company.id,
          warehouse_id: dataExchangeDelivery.value.warehouse_id.value,
          m_user_created_id: CommonService.getUserId(),
          delivery_id: dataExchangeDelivery.value.delivery_id.value,
          store_id: dataExchangeDelivery.value.store_id.value,
          delivery_name: dataExchangeDelivery.value.exchange_delivery_name.value,
          delivery_date: dataExchangeDelivery.value.delivery_date.value,
          m_company_receiver_id: dataExchangeDelivery.value.partner_id.value,
          delivery_description: dataExchangeDelivery.value.exchange_delivery_description.value,
          deliveryDetails: listProductsSelected.value,
          useToStoreDelivery: useToStoreDelivery.value,
          productIds: listProductIds.value
        }
        if(syncZaloStore.syncZalo) {
          params.sync_id = syncZaloStore.syncZalo.id
        }
        const url = AppConstant.URL_API_LOCAL + 'api/v1/deliveries/create';
        const res = await deliveryStore.createDeliveries(url, params);
        const prepareErrorMessageApi = await ErrorMessageService.getErrorMessage(res)
        if(prepareErrorMessageApi === undefined) {
          listProductsSelected.value.forEach((product) => {
            product.error = false
          })
          await CommonService.showAlertPopup({
            title: res?.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1000,
            width: '800px'
          });

          dataBillToPrint.value = {
            date: dataExchangeDelivery.value.delivery_date.value,
            partnerName: dataExchangeDelivery.value.partner_id.options.find(p => p.value == dataExchangeDelivery.value.partner_id.value)?.name,
            items: listProductsSelected.value,
            total: totalPrice.value
          };
          isShowBill.value = false;
          nextTick(() => {
            isShowBill.value = true;
          });
        }else {
          showProductError(prepareErrorMessageApi);
        }
      }
    }

    function showProductError(errors) {
      errors.forEach((error) => {
        const arrErr = error.split('_');
        errorMessageApi.value.push(arrErr[1] ?? '')
        const productErrorIndex = listProductsSelected.value.findIndex((item) => item.product_code === (arrErr[0] ?? ''))
        if(productErrorIndex >= 0) {
          listProductsSelected.value[productErrorIndex].error = true
        }
      })
    }
    function onChange(value, name) {
      dataExchangeDelivery.value[name].value = value
    }
    function validateForm(value, name) {
      if(name === 'exchange_delivery_name') {
        dataExchangeDelivery.value.exchange_delivery_name.isError = false;
        dataExchangeDelivery.value.exchange_delivery_name.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.exchange_delivery_name.isError = true;
          dataExchangeDelivery.value.exchange_delivery_name.error = ErrorText.REQUIRED(dataExchangeDelivery.value.exchange_delivery_name.label);
          errors.value = true
        }
      }
      if(name === 'warehouse_id') {
        dataExchangeDelivery.value.warehouse_id.isError = false;
        dataExchangeDelivery.value.warehouse_id.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.warehouse_id.isError = true;
          dataExchangeDelivery.value.warehouse_id.error = ErrorText.REQUIRED(dataExchangeDelivery.value.warehouse_id.label);
          errors.value = true
        }
      }
      if(name === 'store_id') {
        dataExchangeDelivery.value.store_id.isError = false;
        dataExchangeDelivery.value.store_id.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.store_id.isError = true;
          dataExchangeDelivery.value.store_id.error = ErrorText.REQUIRED(dataExchangeDelivery.value.store_id.label);
          errors.value = true
        }
      }
      if(name === 'partner_id') {
        dataExchangeDelivery.value.partner_id.isError = false;
        dataExchangeDelivery.value.partner_id.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.partner_id.isError = true;
          dataExchangeDelivery.value.partner_id.error = ErrorText.REQUIRED(dataExchangeDelivery.value.partner_id.label);
          errors.value = true
        }
      }
      if(name === 'delivery_date') {
        dataExchangeDelivery.value.delivery_date.isError = false;
        dataExchangeDelivery.value.delivery_date.error = ''
        errors.value = false
        if(!value) {
          dataExchangeDelivery.value.delivery_date.isError = true;
          dataExchangeDelivery.value.delivery_date.error = ErrorText.REQUIRED(dataExchangeDelivery.value.delivery_date.label);
          errors.value = true
        }
        if(value && new Date(value) <= new Date()) {
          dataExchangeDelivery.value.delivery_date.isError = true;
          dataExchangeDelivery.value.delivery_date.error = ErrorMessageConstant.ERROR_ARRIVAL_VALIDATE_DATE;
          errors.value = true
        }
      }
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function onChangeProductQuantity(value, name) {
      totalPrice.value = 0
      const productId = name.split('_')[1]
      listProductsSelected.value.forEach((product) => {
        if(parseInt(productId) === parseInt(product.id)) {
          product.error_empty_quantity = !value && value !== false;
          if(!product.error_empty_quantity) {
            product.product_quantity_set = isNaN(parseFloat(value)) ? 0 : value
            product.total_price_origin = product.product_selling_price * product.product_quantity_set;
            product.total_price_tax = (1 + parseInt(product.product_tax)/100) * product.total_price_origin;
          }
        }
        if(!product.error_empty_quantity) {
          const amount = product.product_selling_price * product.product_quantity_set;
          const fee = product.product_selling_price * product.product_quantity_set * (product.product_tax / 100);
          totalPrice.value += (amount + fee);
        }
      });
    }

    function onChangeProductSellingPrice(value, name) {
      totalPrice.value = 0
      let product_price_current = 0;
      const productId = name.split('_')[1]
      listProductsSelected.value.forEach((product) => {
        if(parseInt(productId) === parseInt(product.id)) {
          product.error_selling = !value && value !== false;
          if(!product.error_selling) {
            product_price_current = value > 0 ? value : product.product_selling_price;
            product.total_price_origin = product_price_current * product.product_quantity_set;
            product.total_price_tax = (1 + parseInt(product.product_tax)/100) * product.total_price_origin;
          }
        }
        if(!product.error_selling) {
          product.product_selling_price = value;
          const amount = product_price_current * product.product_quantity_set;
          const fee = product_price_current * product.product_quantity_set * (product.product_tax / 100);
          totalPrice.value += (amount + fee);
        }
      });
    }

    function onChangeStoreDelivery(value) {
      useToStoreDelivery.value = value
    }

    function removeProduct(productId, productName) {
      CommonService.showAlertPopup({
        title: ConfirmText.CONFIRM_REMOVE(productName),
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        timer: undefined,
        width: '800px'
      }).then((result) => {
        if (result.isConfirmed) {
          listProductsSelected.value = listProductsSelected.value.filter((product) => parseInt(product.id) !== productId)
          totalPrice.value = 0
          listProductsSelected.value.forEach((product) => {
            product.total_price_origin = product.product_selling_price * product.product_quantity_set;
            product.total_price_tax = (1 + parseInt(product.product_tax)/100) * product.total_price_origin;
            const amount = product.product_selling_price * product.product_quantity_set;
            const fee = product.product_selling_price * product.product_quantity_set * (product.product_tax / 100);
            totalPrice.value += (amount + fee);
          });
          checkProductsWithMaster(listProductsSelected.value)
        }
      });
    }

    function checkProductsWithMaster(listProductsCurrent) {
      disabledStoreDelivery.value = true
      if(listProductsCurrent.length !== listProductIds.value.length) {
        disabledStoreDelivery.value = false
      }
      if(listProductsCurrent.length === listProductIds.value.length) {
        listProductsCurrent.forEach((product) => {
          if(!listProductIds.value.includes(product.id)) {
            disabledStoreDelivery.value = false
          }
        })
      }
    }

    function showModalProductList() {
      eventClickShowModal.value = true
      isLoading.value = true
    }

    function showModalProduct(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModal.value = false
          isLoading.value = false
          stateModal.modalDeliveryProductList.show()
        }, 1000);
        return;
      }
      stateModal.modalDeliveryProductList.hide()
    }

    function eventSearchProduct(isSearch) {
      if(!eventClickShowModal.value) {
        isLoading.value = isSearch
      }
    }

    function eventGetListProductsSelected(listProductsSelectedCurrent) {
      listProductsSelected.value = listProductsSelectedCurrent
      listProductsSelected.value.forEach((product) => {
        product.tax_rate = product.product_tax;
        product.product_quantity_set = 0;
        listProductIds.value.push(product.id);
      })
      checkProductsWithMaster(listProductsSelected.value)
    }

    function resetForm() {
      totalPrice.value = 0;
      dataExchangeDelivery.value.delivery_date.value = ''
      dataExchangeDelivery.value.exchange_delivery_description.value = ''
      dataExchangeDelivery.value.exchange_delivery_name.value = ''
      dataExchangeDelivery.value.delivery_id.value = ''
      dataExchangeDelivery.value.delivery_id.options = []
      dataExchangeDelivery.value.partner_id.value = ''
      useToStoreDelivery.value = false
      disabledStoreDelivery.value = true
      listProductsSelected.value = []
      listProductIds.value = []
      errorMessageApi.value = []
      dataBillToPrint.value = {}
    }

    function handlePrintSuccess(data) {
      resetForm()
      this.isShowBill = false;
    }
    function handleCancel() {
      resetForm()
      this.isShowBill = false;
    }

    return {
      listPartners,
      totalPrice,
      listProductsSelected,
      dataExchangeDelivery,
      labelSelectProduct,
      dataHeaderTable,
      deliveryStore,
      isLoading,
      eventClickShowModal,
      checkSubmitActive,
      errors,
      errorMessageApi,
      useToStoreDelivery,
      disabledStoreDelivery,
      isShowBill,
      dataBillToPrint,
      showModalProductList,
      onChangeStoreDelivery,
      CommonService,
      onChange,
      validateForm,
      createDelivery,
      onChangeProductQuantity,
      onChangeProductSellingPrice,
      removeProduct,
      showModalProduct,
      eventSearchProduct,
      eventGetListProductsSelected,
      handlePrintSuccess,
      handleCancel,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
